// src/Tabs.tsx
import React, { useEffect, useState } from "react";
import {
  IonTabs,
  IonRouterOutlet,
  IonTabBar,
  IonTabButton,
  IonIcon,
  IonLabel,
} from "@ionic/react";
import { Route, Redirect } from "react-router-dom";
import { Capacitor } from "@capacitor/core";
import {
  chatbubblesOutline,
  compassOutline,
  createOutline,
  alertCircleOutline,
  megaphoneOutline,
} from "ionicons/icons";

import Home from "./pages/Home";
import Explore from "./pages/Explore";
import Contribute from "./pages/Contribute";
import Emergency from "./pages/Emergency";
import CityUpdates from "./pages/CityUpdates";
import Onboarding from "./pages/Onboarding";
import DesktopSidebar from "./components/DesktopSidebar";
import { track, trackScreen } from "./analytics";

const Tabs: React.FC = () => {
  const [showOnboarding, setShowOnboarding] = useState(false);

  useEffect(() => {
    const hasSeenTutorial = localStorage.getItem("hasSeenTutorial");
    if (!hasSeenTutorial) {
      setShowOnboarding(true);
    }
  }, []);

  const handleFinishTutorial = () => {
    localStorage.setItem("hasSeenTutorial", "true");
    setShowOnboarding(false);
    track("onboarding_completed");
  };

  const isWeb = Capacitor.getPlatform() === "web";

  if (showOnboarding && !isWeb) {
    return <Onboarding onFinish={handleFinishTutorial} />;
  }

  return (
    <>
      {/* Desktop-only left nav; hidden on mobile via CSS */}
      <DesktopSidebar />
      <IonTabs
        onIonTabsDidChange={(e) => {
          track("tab_selected", { tab: e.detail.tab });
          trackScreen(e.detail.tab);
        }}
      >
      <IonRouterOutlet>
        {/* One stack per tab */}
        <Route exact path="/tabs/home" component={Home} />
        <Route exact path="/tabs/updates" component={CityUpdates} />
        <Route exact path="/tabs/explore" component={Explore} />
        <Route exact path="/tabs/contribute" component={Contribute} />
        <Route path="/tabs/emergency" component={Emergency} exact />

        {/* Default inside /tabs -> /tabs/home */}
        <Redirect exact from="/tabs" to="/tabs/home" />
      </IonRouterOutlet>

      <IonTabBar slot="bottom">
        <IonTabButton tab="home" href="/tabs/home">
          <IonIcon icon={chatbubblesOutline} />
          <IonLabel>AI Chat</IonLabel>
        </IonTabButton>

        <IonTabButton tab="updates" href="/tabs/updates">
          <IonIcon icon={megaphoneOutline} />
          <IonLabel>Updates</IonLabel>
        </IonTabButton>

        <IonTabButton tab="explore" href="/tabs/explore">
          <IonIcon icon={compassOutline} />
          <IonLabel>Navigate</IonLabel>
        </IonTabButton>

        <IonTabButton tab="emergency" href="/tabs/emergency">
          <IonIcon icon={alertCircleOutline} />
          <IonLabel>Emergency</IonLabel>
        </IonTabButton>

        <IonTabButton tab="contribute" href="/tabs/contribute">
          <IonIcon icon={createOutline} />
          <IonLabel>Contribute</IonLabel>
        </IonTabButton>
      </IonTabBar>
      </IonTabs>
      {showOnboarding && isWeb && <Onboarding onFinish={handleFinishTutorial} asDialog />}
    </>
  );
};

export default Tabs;
